import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from '@/app/App'
import { bootstrapSession } from '@/shared/api/session'
import '@/shared/i18n'
import '@/styles/index.css'

// Se dispara antes del render y fuera de React: en StrictMode los efectos se
// ejecutan dos veces y no queremos dos rotaciones del refresh token.
bootstrapSession()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
